module.exports = __webpack_public_path__ + "img/approve.e1bd2942.png";